import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import goolge from "../../assets/images/google.svg";
import apple from "../../assets/images/apple.svg";
import { ImEye } from "react-icons/im";
import { ImEyeBlocked } from "react-icons/im";
import LoginElement from "../auth/left-panel";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext"; // Import Auth Context


const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const { login } = useAuth(); // Use Auth Context

  const handleSignUpClick = () => {
    // Navigate to the SignIn component
    navigate('/signup'); // Updated navigation logic
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // ✅ Basic email validation
    return emailRegex.test(email);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    let validationErrors = {};

    // Email validation
    if (!email) {
      validationErrors.email = "Email is required.";
    } else if (!validateEmail(email)) {
      validationErrors.email = "Please enter a valid email address.";
    }

    // Password validation
    if (!password) {
      validationErrors.password = "Password is required.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // ✅ Proceed with login if no errors
    console.log("Logging in with:", { email, password });
    setErrors({});
    login(); // Update Auth State

    // If login is successful, navigate to home page
    navigate('/'); // Adjust the path to your home page as necessary
  };


  return (
    <div className="login">
      <div className="content-section">
        <LoginElement />
      </div>
      <div className="form-section">
        <div className='l-form-element'>
          <h1>Sign In to Fanhub</h1>
          <div className="d-grid gap-3 social-login">
            <Button className="google-btn">
              <img src={goolge} alt="Google" className="icon" /> Sign Up with Google
            </Button>
            <Button className="apple-btn">
              <img src={apple} alt="Apple" className="icon" /> Sign Up with Apple
            </Button>
          </div>
          <div className="or-devider devider-sg">
            <span>OR</span>
          </div>
          {/* Display error message */}

          <Form onSubmit={handleLogin}>
            {/* Email Input Group with Validation */}
            <div className="mb-3">
              <Form.Floating>
                <Form.Control
                  id="floatingInputCustom"
                  type="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={errors.email ? "is-invalid" : ""}
                />
                <label htmlFor="floatingInputCustom">Email address</label>
              </Form.Floating>
              {errors.email && <div className="text-danger mt-1">{errors.email}</div>} {/* ✅ Email error message */}
            </div>

            {/* Password Input Group with Validation */}
            <div className="mb-3 position-relative">
              <Form.Floating>
                <Form.Control
                  id="floatingPasswordCustom"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={errors.password ? "is-invalid" : ""}
                />
                <label htmlFor="floatingPasswordCustom">Password</label>
              </Form.Floating>
              <Button
                variant="outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
                className="position-absolute top-50 translate-middle-y password-view-btn"
                style={{ border: "none" }}
              >
                {showPassword ? <ImEyeBlocked /> : <ImEye />}
              </Button>
              {errors.password && <div className="text-danger mt-1">{errors.password}</div>} {/* ✅ Password error message */}
            </div>

            {/* Submit button */}
            <Button type="submit" className="btn btn-primary w-100 login-btn">
              Sign In
            </Button>

            {/* Forgot Password link */}
            <div className="forgot-password mt-2">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
          </Form>
          <div className="signup-btn-element">
            <p>Don’t have an account?</p>
            <Button variant="outline-primary" className="w-100 mt-3 signup-btn" onClick={handleSignUpClick}>
              Sign Up
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
